<section appReveal class="dv-section w-full px-4 sm:px-8">
    <div class="dv-inner mx-auto flex w-full max-w-[1200px] flex-col">

        <!-- Split header: heading left, body copy right (stacks on mobile). -->
        <div class="dv-head grid w-full gap-6 lg:grid-cols-2 lg:gap-12">
            @if (link) {
                <a [routerLink]="link" class="dv-heading-link">
                    <h2 class="dv-heading font-outfit font-bold" [innerHTML]="section.headingHtml"></h2>
                </a>
            } @else {
                <h2 class="dv-heading font-outfit font-bold" [innerHTML]="section.headingHtml"></h2>
            }
            @if (bodyLead.length) {
                <div class="dv-prose font-inter space-y-4">
                    @for (paragraph of bodyLead; track $index) {
                        <p>{{ paragraph }}</p>
                    }
                </div>
            }
        </div>

        <p class="dv-eyebrow r-up font-outfit font-bold mt-14 text-center">{{ eyebrow }}</p>

        <ul class="dv-grid mt-10 flex w-full flex-wrap justify-center gap-x-6 gap-y-12">
            @for (card of cards; track $index) {
                <li class="dv-card r-scale" [style.--reveal-delay]="$index * 70 + 'ms'">
                    @if (card.link) {
                        <a [routerLink]="card.link" class="dv-card-link" [attr.aria-label]="card.label">
                            <img class="dv-icon" [src]="'images/landing/dev-icons/' + card.icon" alt=""
                                aria-hidden="true" loading="lazy" />
                            <span class="dv-pill"><span class="dv-pill-label">{{ card.label }}</span></span>
                        </a>
                    } @else {
                        <div class="dv-card-link" [attr.aria-label]="card.label">
                            <img class="dv-icon" [src]="'images/landing/dev-icons/' + card.icon" alt=""
                                aria-hidden="true" loading="lazy" />
                            <span class="dv-pill"><span class="dv-pill-label">{{ card.label }}</span></span>
                        </div>
                    }
                </li>
            }
        </ul>

        @if (section.outro?.length) {
            <div class="dv-outro font-inter space-y-4 mt-12 mx-auto max-w-[820px] text-center">
                @for (paragraph of section.outro; track $index) {
                    <p>{{ paragraph }}</p>
                }
            </div>
        }
    </div>
</section>
